import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { ButtonCSSStyle, ButtonCSSStyleImpl } from '../../../toolkit/button/buttoncss';

export interface ConfirmRequestCancelButtonCSSStyle extends ButtonCSSStyle
{
    getButtonStyle(): object;
    getButtonText(): object;
}

export class ConfirmRequestCancelButtonCSSStyleImpl extends ButtonCSSStyleImpl implements ConfirmRequestCancelButtonCSSStyle 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "pointer",
        outline:'none'

      };
    }

    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '40px',
        float: 'left', 
        border:'1px solid #FFCD00',
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor:"#FFFFFF",
        cursor: "pointer",
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none',
        fontFamily:this.getContext().getResources().getFontFamily(),
   
      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_4), 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            fontWeight:900,
            height: "20px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/confirmrequest/confirmrequestcancelbutoncss.tsx